import { render } from "./IconMenus.vue?vue&type=template&id=00c12b59"
import script from "./IconMenus.vue?vue&type=script&lang=js"
export * from "./IconMenus.vue?vue&type=script&lang=js"

import exportComponent from "/Users/saleem/Sites/unitedtours/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__